import { isEqual } from "lodash";

export const syncAnswer = ({ mode, newVal, oldVal, data }) => {
  // return;
  if (mode.value == 2 && newVal && oldVal) {
    Object.keys(newVal).forEach((newValKey) => {
      try {
        if (newVal[newValKey].hasOwnProperty("answer") && newVal[newValKey].hasOwnProperty("score")) {
          if (!isEqual(newVal[newValKey].value, oldVal[newValKey].value)) {
            data.value[newValKey].answer = newVal[newValKey].value;
          }
        }
      } catch (e) {
        console.log(e);
      }
    });
  }
};
